/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import type { LoginResponse, SendCodeResponse, UserInfo } from '../types';
import { API_BASE_URL, clearCsrfTokenCache, requestJson, type RequestJsonOptions } from './httpClient';

const AGENT_CODE_REGEX = /^[a-z][a-z0-9_-]{2,31}$/;

const resolveClientAgentCode = () => {
  if (typeof window === 'undefined') return '';
  const params = new URLSearchParams(window.location.search || '');
  const raw = params.get('agentCode') || params.get('agent') || '';
  const text = raw.trim().toLowerCase();
  return AGENT_CODE_REGEX.test(text) ? text : '';
};

export const fetchUser = async (options?: RequestJsonOptions) =>
  requestJson<UserInfo>(`${API_BASE_URL}/user`, undefined, options);

export const sendLoginCode = async (phone: string) =>
  requestJson<SendCodeResponse>(
    `${API_BASE_URL}/auth/send-code`,
    {
      method: 'POST',
      body: JSON.stringify({
        phone,
        ...(resolveClientAgentCode() ? { agentCode: resolveClientAgentCode() } : {}),
      }),
    },
    { skipAuth: true }
  );

export const loginByCode = async (phone: string, code: string, agreed: boolean) =>
  requestJson<LoginResponse>(
    `${API_BASE_URL}/auth/login`,
    {
      method: 'POST',
      body: JSON.stringify({
        phone,
        code,
        agreed,
        ...(resolveClientAgentCode() ? { agentCode: resolveClientAgentCode() } : {}),
      }),
    },
    { skipAuth: true }
  );

export const logout = async () => {
  const result = await requestJson<void>(`${API_BASE_URL}/auth/logout`, {
    method: 'POST',
  });
  clearCsrfTokenCache();
  return result;
};

export const sendPresenceHeartbeat = async () =>
  requestJson<void>(`${API_BASE_URL}/presence/heartbeat`, {
    method: 'POST',
  });
